<template>
    <div>
       <mask-pop @onClose="onShowGoods()" :show="show" >
          <div class="choose-goods">
               <div class="wrapper" @click.stop  >
                    <img :src="goodDetailList.combo_thumb" alt="">
                    <div class="goods-content">
                        <img class="title-img title-img1" src="../../assets/img/goods/tittle1.png" alt="">
                        <div class="goods-title" >{{goodDetailList.combo_title}}</div>
                        <img class="title-img" src="../../assets/img/goods/tittle2.png" alt="">
                        <div class="goods-list">
                            <p class="goods-rich-text" v-html="goodDetailList.combo_content"></p>
                        </div>
                          <!-- <div class="button">
                                <button  @click="onShowGoods(id)">选择</button>
                            </div> -->
                    </div>
                </div>
                <div class="close"  @click.stop="onShowGoods()">
                    <img src="./../../assets/img/goods/close.png" alt="">
                </div>
          </div>
       </mask-pop>
    </div>
</template>
<script>
 import maskPop from "@/components/maskPop"
export default {
  
    props:['showGoods','goodDetailList','id'],
    data() {
    return {
      show: false,
       swiperOption: {
            pagination: {
            el: '.swiper-pagination'
          },
        }
    }
  },
  watch:{
      showGoods:function(){
          this.show = this.showGoods
      }
  },
  components:{
      maskPop
  },
   methods: {
        onShowGoods(id){
           
            if(id) {
                
                this.$store.commit('changeRadio',{
                    radio:id
                })
            }
            this.$emit('onShowGoods')
        }
    },
}
</script>
<style lang="scss" scoped>
    .choose-goods{
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        height: 100%;
        font-size: 28px;
       
        p{
              font-size: 28px;
              
        }
        .goods-content1{
            font-size: 32px;
            padding: 30px;
            padding-left: 20px;

        }
        //  .wrapper /deep/ .swiper-pagination-bullet{
        //     background: #ffffff;
        // }
        //  .wrapper /deep/ .swiper-pagination-bullet-active {
        //     background: #FF4646;
        // }
        // .swiper{
        //     position: relative;
        // }
       
        .wrapper{
            width:616px;
            height:948px;
            display: inline-block;
            background:rgba(255,255,255,1);
            box-shadow:0px 4px 32px 0px rgba(4,0,0,0.14);
            border-radius:10px;
            overflow-y: scroll;


            img{
                    width:616px;
                    height: 380px;
            }
            /deep/ .swiper-pagination-bullet{
                width:12px;
                height:12px;
                background:rgba(255,70,70,1);
                border-radius:50%;
            }
           
        }
       .close{
            margin-top: 20px;
                img{
                    width: 42px;
                    height: 42px;
                }
            }
        .goods-content{
            padding: 0px 20px;
            width: 100%;
            box-sizing: border-box;
            font-size:28px;
            font-family:PingFang SC;
            font-weight:500;
            color:rgba(102,102,102,1);
            line-height:44px;
            img{
                max-width: 100% !important;
                height: auto !important;
            }
            .goods-title{
                font-size:30px;
                font-family:Source Han Sans CN;
                font-weight:bold;
                color:rgba(34,34,34,1);
                text-align: center;
                padding: 25px 0px;
                width: 404px;
                margin:  0 auto;
            }
            .title-img{
                width: 492px;
                display: block;
                margin: 0 auto;
                
            }
            .title-img1{
              margin-top: 40px;
                
            }
            .goods-list{
                font-size:28px;
                font-family:PingFang SC;
                font-weight:500;
                color:rgba(102,102,102,1);
                font-size: 0;
                img{
                    display: block;
                }
                .goods-rich-text{
                    // padding-bottom:100px ;
                    // overflow: hidden;
                }
                
            }
            .button{
                // position: absolute;
                // bottom: 44px;
                text-align: center;
                width: 100%;
                position: relative;
                
                button{
                    width:500px;
                    height:80px;
                    background:linear-gradient(0deg,rgba(255,74,74,1),rgba(255,70,70,1));
                    border-radius:40px;
                    border:none;
                    font-size:38px;
                    font-family:PingFang SC;
                    font-weight:500;
                    color:rgba(255,255,255,1);
                }
            }
        }
    }
</style>